import React from 'react';
import TableView from '../tableView';
import { SensorsResult } from '../../Model/contact';
import { useTranslation } from 'react-i18next';

interface Props {
  sensors: SensorsResult[],
  tabulator: any,
  filterSelectOptions: {},
  formatDate: (value: string) => void
}

export const SensorsTable = ({
  filterSelectOptions,
  sensors,
  tabulator,
  formatDate
}: Props) => {
  const { t } = useTranslation();
  const sensorColumns = [
    {
      title: t('ALGORAND_ACCOUNT'),
      field: 'algorandAccount',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('ACTIVE_LICENSE'),
      field: 'isLicenseActive',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('OWNER'),
      field: 'isOwner',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('LAST_UPDATE'),
      field: 'lastUpdate',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions,
      formatter: (cell: any) => formatDate(cell.getValue())
    },
    {
      title: t('SENSOR_ID'),
      field: 'sensorId',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('SENSOR_TYPE'),
      field: 'sensorType',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    }
  ];

  return <>    {
        sensors.length > 0 ? <TableView
            t={t}
            ref={tabulator} 
            data={sensors} 
            columns={sensorColumns} 
            id={'sensor-list'} />
          : <p className='noData'>{t('NO_DATA')}</p>}
    </>;
};